import axios from './interceptor'
import { baseUrl } from './config'

export default {
  async getActiveTables () {
    const res = await axios.get(`${baseUrl}/c/table`)
    return res.data
  },
  async listActiveOrders (table) {
    const res = await axios.get(`${baseUrl}/c/table/order`, {
      params: {
        table,
      },
    })
    return res.data
  },
}



// WEBPACK FOOTER //
// ./src/services/api/table.js